import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { PitchDeck } from './pages/PitchDeck';
import { Dashboard } from './pages/Dashboard';
import { AgencyPortal } from './pages/AgencyPortal';
import { ResortSalesDeck } from './pages/ResortSalesDeck';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/deck" element={<PitchDeck data-id="element-5" />} data-id="element-4" />
        <Route path="/app" element={<Dashboard data-id="element-7" />} data-id="element-6" />
        <Route path="/agency" element={<AgencyPortal data-id="element-9" />} data-id="element-8" />
        <Route path="/sales" element={<ResortSalesDeck data-id="element-11" />} data-id="element-10" />
      </Routes>
    </BrowserRouter>;
}